import { useAnalytics } from 'hooks/useAnalytics';
import { getProxyDomainByStage } from 'utils/url';
import { useIntersectionObserver } from './useIntersectionObserver';
import { useCaptureClick } from './useCaptureClick';
import type { MutableRefObject } from 'react';

const stage = process.env.STAGE as string;

const sendReviewsEventToFullStory = (eventName: string): void => {
  const {
    FS,
    location: { pathname },
  } = window;

  FS?.event(eventName, {
    url: `${getProxyDomainByStage(stage)}${pathname}`,
  });
};

const sendReviewsEventToGoogleAnalytics = (
  trackEvent: (params: Record<string, string>, callback?: () => void) => void,
  eventName: string,
): void => {
  const {
    location: { pathname },
  } = window;

  trackEvent({
    category: `Reviews|${getProxyDomainByStage(stage)}${pathname}`,
    action: `Reviews|${eventName}`,
    label: `Reviews|${eventName}`,
  });
};

export const useCaptureIntersections = (
  ref: MutableRefObject<Element | null>,
): void => {
  const { trackEvent } = useAnalytics();

  useIntersectionObserver(
    ref,
    {
      threshold: 0,
      rootMargin: '-50% 0px -50% 0px',
    },
    () => {
      sendReviewsEventToFullStory('reviewsSeen');
      sendReviewsEventToGoogleAnalytics(trackEvent, 'reviewsSeen');
    },
  );

  useCaptureClick(ref, () => {
    sendReviewsEventToFullStory('reviewsInteraction');
    sendReviewsEventToGoogleAnalytics(trackEvent, 'reviewsInteraction');
  });
};
